angular.module('ihestiaWidgets.policyDetails')
  .controller('ihestiaLifePolicyTerminationModalCtrl', ['$scope', function($scope) {
    $scope.helper.init();
    $scope.tplData = $scope.helper.tplData;
    $scope.onChooseTerminationType = $scope.helper.onChooseTerminationType;
  }]);
